/**
* @desc Auxillary file
* @author Jamshith 
*/

const aux =(props) =>props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/hoc/Auxi/Auxi.js